import {
    Box, Button, Card, CardContent,
    Container, Typography
} from '@mui/material';
import { RouteComponentProps, useHistory, withRouter } from 'react-router-dom';
import AutomationsTable from './AutomationsTable';
import ModalWrapper from '../common/modal/wrapper';
import { Plus } from '../../icons/plus';
import AutomationsForm from './AutomationsForm';
import { FACTS, ROUTES } from '../../constants';

const Automations: React.FC<RouteComponentProps> = ({ history, match }) => {
    const navigate = useHistory()

    return (
        <Box
            sx={{
                backgroundColor: "background.paper",
                display: "flex",
                flexDirection: "column",
                height: 'calc(100vh - 100px)',
                overflow: 'hidden'
            }}
        >
            <Container
                maxWidth={false}
                disableGutters
                sx={{
                    p: 3,
                    pt: 1.5,
                    display: "flex",
                    flexDirection: "column",
                    height: '100%',
                    overflow: 'hidden'
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        mb: 1,
                        flexShrink: 0
                    }}
                >
                    <Typography variant="h4" sx={{ mr: 2 }}>
                        Automations
                    </Typography>
                    <ModalWrapper
                        maxWidth="md"
                        title="Add Automation"
                        trigger={
                            <Button
                                color="inherit"
                                size="small"
                                variant="outlined"
                                sx={{ borderColor: "neutral.300" }}
                            >
                                Add <Plus />
                            </Button>
                        }
                        child={
                            <AutomationsForm
                                preventRedirect
                                facts={[...FACTS]}
                                commonFacts={[]}
                                callback={() => {
                                    navigate.push(ROUTES.AUTOMATIONS)
                                }}
                            />
                        }
                    />
                </Box>

                <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
                    <AutomationsTable />
                </Box>
            </Container>
        </Box>


    );
};


export default withRouter(Automations);
